<template>
  <div class="left">
    <div class="fifter">
      <el-input @keyup.enter.native="filterDomain" prefix-icon="el-icon-search" v-model="filterText">
      </el-input>
      <el-button type="text" :title="showStatusTitle" @click="unFoldAll" v-show="showStatusTitle === $t('LanguageLib.EXPAND') ? true : false">{{showStatusTitle}}</el-button>
      <el-button type="text" :title="showStatusTitle" @click="collapseAll" v-show="showStatusTitle === $t('LanguageLib.EXPAND') ? false : true">{{showStatusTitle}}</el-button>
    </div>
    <div class="treeBox">
      <el-tree class="filter-tree" :default-expanded-keys="twoNodeArr" :expand-on-click-node="false" :highlight-current="true" @node-expand="changeText" @node-collapse="changeText" @node-click="treeNodeClick" :render-content="renderContent" :data="districtTreeData" :props="defaultProps" :default-expand-all="showStatus"  :filter-node-method="filterNode" :current-node-key="checkDomainId" node-key="id" ref="tree">
      </el-tree>
    </div>
  </div>
</template>

<script>
import basicdataApi from '@/api/basicdata'
export default {
  name: 'DistrictTree',
  props: {
    districtData: Array, // 数据源是一个list
    districtTreeData: Array, // 树状结构
    twoNodeArr: Array, // 为了做展开和收起数据字段是id的list
    checkDomainId: String // 选中id
  },
  data () {
    return {
      filterText: '',
      renderContent: function (h, { node, data }) {
        var openidstr = node.label.slice(0, 3)
        if (openidstr === 'wx|' && JSON.parse(this.$commonfun.localStorage.getitem('qyuser'))) {
          return <ww-open-data style="height:20px;font-size:14px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(96,98,102,1);line-height:20px;" type="departmentName" openid={node.label.slice(3)}></ww-open-data>
        } else {
          return <span style="height:20px;font-size:14px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(96,98,102,1);line-height:20px;">{node.label}</span>
        }
      },
      showStatus: false, // 组织树默认收起
      showStatusTitle: this.$t('LanguageLib.COLLAPSE'),
      searchTreeIds: [], // 通过接口获取企微id
      defaultProps: {
        children: 'childDomainTrees',
        label: 'districtName'
      }
    }
  },
  methods: {
    filterDomain () {
      if (this.$commonfun.localStorage.getitem('qyuser') === 'true') {
        basicdataApi.getSearchName('post', '/QYUser/Search',
          {
            ownerId: this.$commonfun.localStorage.getitem('ownerId'),
            ownerCode: this.$commonfun.localStorage.getitem('ownerCode'),
            search: this.filterText,
            queryType: 2
          }, 'Api')
          .then(res => {
            this.searchTreeIds = res.data
            this.$refs.tree.filter(this.filterText)
          })
          .catch(err => {
            this.$commonfun.console.log(err)
          })
      } else {
        this.searchTreeIds = []
        this.$refs.tree.filter(this.filterText)
      }
    },
    filterNode (value, data) {
      if (!value) {
        return true
      } else {
        if (value.slice(0, 3) === 'wx|') {
          return false
        } else {
          return (data.districtName.indexOf(value) !== -1 && data.districtName.indexOf('wx|') === -1) || this.$commonfun.IsInArray(this.searchTreeIds, data.id)
        }
      }
    },
    // 全部展开
    unFoldAll () {
      const self = this
      // 将没有转换成树的原数据
      const treeList = this.districtData
      for (let i = 0; i < treeList.length; i++) {
        // 将没有转换成树的原数据设置key为... 的展开
        if (self.$refs.tree.store.nodesMap[treeList[i].id]) {
          self.$refs.tree.store.nodesMap[treeList[i].id].expanded = true
        }
      }
      // 将文本变成一键收起
      this.showStatusTitle = this.$t('LanguageLib.COLLAPSE')
    },
    // 全部折叠
    collapseAll () {
      const self = this
      const treeList = this.districtData
      for (let i = 0; i < treeList.length; i++) {
        if (self.$refs.tree.store.nodesMap[treeList[i].id]) {
          self.$refs.tree.store.nodesMap[treeList[i].id].expanded = false
        }
      }
      // 将文本变成一键展开
      this.showStatusTitle = this.$t('LanguageLib.EXPAND')
    },
    // 树节点点击
    treeNodeClick (data, node, item) {
      // 自定义一个事件addcheck-treedata 为了拿{ districtName: data.districtName, id: data.id, districtCode: data.districtCode }数据
      this.$emit('addcheck-treedata', { districtName: data.districtName, id: data.id, districtCode: data.districtCode })
    },
    changeText (data, node, item) {
      setTimeout(() => {
        const treeList = this.districtData
        // 定义一个变量为收起节点的数量
        var num = 0
        var delnum = 0
        for (let i = 0; i < treeList.length; i++) {
          if (this.$refs.tree.store.nodesMap[treeList[i].id]) {
            if (this.$refs.tree.store.nodesMap[treeList[i].id].expanded) {
              this.showStatusTitle = this.$t('LanguageLib.COLLAPSE')
            } else {
              num++
            }
          } else {
            delnum++
          }
        }
        // 收起节点的数量与数据长度相等改变文字
        if ((num + delnum) === treeList.length) {
          this.showStatusTitle = this.$t('LanguageLib.EXPAND')
        }
      }, 100)
    }
  }
}
</script>

<style lang="scss">
.left{
  background: #fff;
  width:320px;
  height: 535px;
  border: 1px solid #f2f2f2;
  .fifter{
    height: 30px;
    padding: 10px 0 10px 20px;
    margin: 0 auto;
    border-bottom: 1px solid #f2f2f2;
    .el-input{
      width: 220px;
      input{
        height: 30px;
        line-height: 30px;
        border-radius: 20px;
      }
      .el-icon-search{
        line-height: 30px;
      }
    }
    .el-button--text{
      margin-left: 8px;
      padding: 7px 0;
      color: #3BC6B9;
    }
  }
  .treeBox{
    height: calc( 100% - 51px );
    overflow: auto;
    width: 320px;
  }
  .treeBox::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  .treeBox::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
    background: #E1E1E1;
  }
  .treeBox::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
    border-radius: 5px;
    background: #fff;
  }
}
</style>
